import { render, staticRenderFns } from "./examesvalidacao.vue?vue&type=template&id=e1cf8904&scoped=true"
import script from "./examesvalidacao.vue?vue&type=script&lang=js"
export * from "./examesvalidacao.vue?vue&type=script&lang=js"
import style0 from "./examesvalidacao.vue?vue&type=style&index=0&id=e1cf8904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cf8904",
  null
  
)

export default component.exports